module.exports = __webpack_public_path__ + "media/tema_1_warning1_b_CF1.9999c833.wav";